export const GET_VENUES = 'GET_VENUES';
export const GET_VENUES_SUCCESS = 'GET_VENUES_SUCCESS';
export const GET_VENUES_FAILED = 'GET_VENUES_FAILED';

export const GET_VENUE_BY_ID = 'GET_VENUE_BY_ID';
export const GET_VENUE_BY_ID_SUCCESS = 'GET_VENUE_BY_ID_SUCCESS';
export const GET_VENUE_BY_ID_FAILED = 'GET_VENUE_BY_ID_FAILED';

export const GET_PICTURES_BY_VENUE = 'GET_PICTURES_BY_VENUE';
export const GET_PICTURES_BY_VENUE_SUCCESS = 'GET_PICTURES_BY_VENUE_SUCCESS';
export const GET_PICTURES_BY_VENUE_FAILED = 'GET_PICTURES_BY_VENUE_FAILED';

export const CREATE_VENUE = 'CREATE_VENUE';
export const CREATE_VENUE_SUCCESS = 'CREATE_VENUE_SUCCESS';
export const CREATE_VENUE_FAILED = 'CREATE_VENUE_FAILED';

export const ADD_IMAGE_TO_EVENT = 'ADD_IMAGE_TO_EVENT';
export const ADD_IMAGES_TO_VENUE = 'ADD_IMAGES_TO_VENUE';
export const DELETE_VENUE_PICTURE = 'DELETE_VENUE_PICTURE';
export const DELETE_VENUE_PICTURE_SUCCESS = 'DELETE_VENUE_PICTURE_SUCCESS';
export const DELETE_VENUE_PICTURE_FAILURE = 'DELETE_VENUE_PICTURE_FAILURE';

export const GET_VENUE_FEATURES = 'GET_VENUE_FEATURES';
export const GET_VENUE_FEATURES_SUCCESS = 'GET_VENUE_FEATURES_SUCCESS';
export const GET_VENUE_FEATURES_FAILED = 'GET_VENUE_FEATURES_FAILED';

export const GET_FEATURES_BY_VENUE_ID = 'GET_FEATURES_BY_VENUE_ID';
export const GET_FEATURES_BY_VENUE_ID_SUCCESS = 'GET_FEATURES_BY_VENUE_ID_SUCCESS';
export const GET_FEATURES_BY_VENUE_ID_FAILED = 'GET_FEATURES_BY_VENUE_ID_FAILED';

export const SET_BANNER_VENUE = 'SET_BANNER_VENUE';
export const SET_PRINCIPAL_BANNER_VENUE = 'SET_PRINCIPAL_BANNER_VENUE';
export const SET_CURRENT_VENUE_USER = 'SET_CURRENT_VENUE_USER';

export const UPDATE_VENUE = 'UPDATE_VENUE';
export const UPDATE_VENUE_SUCCESS = 'UPDATE_VENUE_SUCCESS';
export const UPDATE_VENUE_FAILED = 'UPDATE_VENUE_FAILED';
